const CONTENT_EDITOR_SIDEBAR_WIDTH_KEY = "contentEditorSidebarWidth";

export const DEFAULT_CONTENT_EDITOR_SIDEBAR_WIDTH = 520;

const MIN_WIDTH = 260;

export const getContentEditorSidebarWidthKey = (courseId) => {
  if (courseId == null || courseId === "") return CONTENT_EDITOR_SIDEBAR_WIDTH_KEY;
  return `${CONTENT_EDITOR_SIDEBAR_WIDTH_KEY}:${courseId}`;
};

const clampForViewport = (value) => {
  if (typeof window === "undefined") return value;
  const max = Math.max(
    MIN_WIDTH + 40,
    Math.min(1200, window.innerWidth - 360)
  );
  return Math.round(Math.min(max, Math.max(MIN_WIDTH, value)));
};

export const readContentEditorSidebarWidth = (courseId) => {
  if (typeof window === "undefined") return DEFAULT_CONTENT_EDITOR_SIDEBAR_WIDTH;

  try {
    const raw = sessionStorage.getItem(getContentEditorSidebarWidthKey(courseId));
    if (raw == null || raw === "") return DEFAULT_CONTENT_EDITOR_SIDEBAR_WIDTH;
    const n = Number(raw);
    if (!Number.isFinite(n)) return DEFAULT_CONTENT_EDITOR_SIDEBAR_WIDTH;
    return clampForViewport(n);
  } catch (_err) {
    return DEFAULT_CONTENT_EDITOR_SIDEBAR_WIDTH;
  }
};

export const writeContentEditorSidebarWidth = (courseId, widthPx) => {
  if (typeof window === "undefined") return;

  try {
    sessionStorage.setItem(
      getContentEditorSidebarWidthKey(courseId),
      String(Math.round(widthPx))
    );
  } catch (_err) {
    // Ignore storage errors (private mode, quota exceeded, etc.)
  }
};
